import React, { useState } from 'react';
import {
	Row,
	Col,
	Button,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Badge,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from 'reactstrap';
import ReceberContainer from './tabs/receber/receber.container';
import InconformidadeContainer from '../../../../app/common/inconformidade/inconformidade.container';
import ExamesContainer from './tabs/exames/exames.container';
import VincularContainer from '../../../../app/common/vincular/vincular.container';
import EtiquetaContainer from './tabs/etiqueta/etiqueta.container';
import AnexoContainer from './tabs/anexo/anexo.container';
import CancelamentoContainer from './tabs/cancelamento/cancelamento.container';
import MultiplosExamesContainer from './tabs/multiplosExames/multiplos-exames.container';
import DocumentosExternosContainer from '../../../../app/common/documentosExternos/documentos-externos.container';
import RecolhimentoContainer from '../../../../app/common/recolhimento/recolhimento.container';
import RastreabilidadeContainer from '../../../../app/common/rastreabilidade/rastreabilidade.container';
import './material.styles.css';
import classnames from 'classnames';
import * as acessos from '../../../../acessos.const.util';
import ChecklistModalContainer from './tabs/checklist/checklist-modal.container';
import ChecklistContainer from './tabs/checklist/checklist.container';
import NumeroExternoContainer from './tabs/numeroExterno/numero-externo.container';
import IntlMessage from '../../../../helpers/intlMessage';
import ModalInfoObito from '@componentes/modalInformacoesObito';
import { useIntl } from 'react-intl';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import LaudoAgrupadoModal from './modal/laudoagrupado.modal';

function MaterialPage(props) {
	const [openModalInfoObito, setOpenModalInfoObito] = useState(false);
	const [openModalLaudoAgrupado, setOpenModalLaudoAgrupado] = useState(false);
	const [openModalConfirmar, setOpenModalConfirmar] = useState(false);
	const intl = useIntl();

	return (
		props.detalhes !== undefined && (
			<Col
				className="mv-detalhes-container"
				md="12"
				key={props.detalhes.id}
				style={{ height: `${props.altura}px` }}
			>
				<Modal
					isOpen={props.modalRecolhimento}
					toggle={() => props.toggleModalRecolhimento(true)}
				>
					<ModalHeader toggle={() => props.toggleModalRecolhimento(true)}>
						<IntlMessage id="dashboards.examDetail.sampleCollection" />
					</ModalHeader>
					<ModalBody>
						<RecolhimentoContainer
							history={props.history}
							imprimirEtiquetaControle={props.imprimirEtiquetaControle}
							confirmaCallBack={() => {
								props.toggleModalRecolhimento(false);
								props.validarFinalizar(false, true);
							}}
						/>
					</ModalBody>
					<ModalFooter>
						<Button
							style={{ marginRight: 120, marginTop: 1 }}
							className="modalCancelButton"
							color="secondary"
							onClick={() => props.toggleModalRecolhimento(true)}
						>
							<IntlMessage id="dashboards.examDetails.cancel" />
						</Button>
					</ModalFooter>
				</Modal>
				{props.exibirChecklist() &&
					!props.finalizado &&
					!props.exameFinalizado && (
						<ChecklistModalContainer
							isOpen={props.modalChecklist}
							toggle={props.toggleModalChecklist}
							altura={props.altura}
							readonly={false}
						/>
					)}
				{props.modalNumeroExterno &&
					!props.finalizado &&
					!props.exameFinalizado && (
						<NumeroExternoContainer
							open={props.modalNumeroExterno}
							closeModal={props.toggleModalNumeroExterno}
							salvarPendente={() => props.salvar(false)}
							finalizar={() => props.salvar(true)}
						></NumeroExternoContainer>
					)}
				<Modal
					isOpen={props.modalFinalizarSemAmostra}
					toggle={() => props.alterStatus(!props.modalFinalizarSemAmostra)}
				>
					<ModalHeader
						toggle={() => props.alterStatus(!props.modalFinalizarSemAmostra)}
					>
						<IntlMessage id="dashboards.examDetail.finalizeMaterialReceipt" />
					</ModalHeader>
					<ModalBody>{props.msgModalFinalizarSemAmostra}</ModalBody>
					<ModalFooter>
						<Button
							color="secondary"
							onClick={() => props.alterStatus(!props.modalFinalizarSemAmostra)}
						>
							<IntlMessage id="dashboards.reports.no" />
						</Button>
						<Button
							color="primary"
							onClick={() =>
								props.finalizarSemAmostra(!props.modalFinalizarSemAmostra)
							}
						>
							<IntlMessage id="dashboards.reports.yes" />
						</Button>
					</ModalFooter>
				</Modal>
				<Row>
					<Col>
						<div className="tab-container" style={{ height: '85vh' }}>
							<Nav tabs>
								{props.acessoPermitido(
									props.usuario,
									acessos.RecebimentoMaterial
								) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '1' })}
											onClick={() => {
												props.toggle('1');
											}}
										>
											<div>
												<i className="mv-basico-importar"></i>
												<IntlMessage id="dashboards.examDetail.toReceive" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{!props.finalizado && !props.exameFinalizado && (
									<NavItem>
										<NavLink
											onClick={() => {
												props.toggleModalNumeroExterno();
											}}
										>
											<div className="btn-doc-external">
												<i className="fas fa-external-link-square-alt"></i>
												<IntlMessage id="dashboards.examDetail.externalExam" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.NaoConformidades
								) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '2' })}
											onClick={() => {
												props.toggle('2');
											}}
										>
											<div>
												{props.totalNaoConformidades > 0 && (
													<Badge color="primary" pill>
														{props.totalNaoConformidades}
													</Badge>
												)}
												<i className="fas fa-exclamation-circle"></i>
												<IntlMessage id="dashboards.examDetail.Unconformities" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.ExamesEmAberto
								)
								&& (props.detalhes.qtdBlocoExterno<= 0 || props.detalhes.qtdLaminaExterno<= 0)
								 && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '3' })}
											onClick={() => {
												props.toggle('3');
											}}
										>
											<div>
												{props.totalExames > 0 && (
													<Badge color="primary" pill>
														{props.totalExames}
													</Badge>
												)}
												<i className="fas fa-flask"></i>
												<IntlMessage id="dashboards.examDetails.openExams" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.VincularExame
								) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '4' })}
											onClick={() => {
												props.toggle('4');
											}}
										>
											<div>
												{props.totalVinculados > 0 && (
													<Badge color="primary" pill>
														{props.totalVinculados}
													</Badge>
												)}
												<i className="fas fa-link"></i>
												<IntlMessage id="dashboards.examDetail.link" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(props.usuario, acessos.Etiqueta) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '5' })}
											onClick={() => {
												props.toggle('5');
											}}
										>
											<div>
												<i className="mv-basico-codigo_barras"></i>
												<IntlMessage id="dashboards.examDetail.label" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(props.usuario, acessos.Anexo) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '6' })}
											onClick={() => {
												props.toggle('6');
											}}
										>
											<div>
												<i className="mv-basico-anexar"></i>
												<IntlMessage id="dashboards.examDetail.attachment" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(props.usuario, acessos.DocExterno) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '9' })}
											onClick={() => {
												props.toggle('9');
											}}
										>
											<div>
												<i className="fas fa-file-invoice"></i>
												<IntlMessage id="dashboards.examDetail.docExternal" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.MultiplosExames
								) && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '7' })}
											onClick={() => {
												props.toggle('7');
											}}
										>
											<div>
												<i className="mv-basico-faturamento"></i>
												<IntlMessage id="dashboards.examDetails.multipleExams" />
											</div>
										</NavLink>
									</NavItem>
								)}
								{props.acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
									props.acessoPermitido(
										props.usuario,
										acessos.CancelamentoMATERIAL
									) &&
									props.finalizado && (
										<NavItem>
											<NavLink
												className={classnames({ active: props.active === '8' })}
												onClick={() => {
													props.toggle('8');
												}}
											>
												<div>
													<i className="mv-basico-cancelar"></i>
													<IntlMessage id="dashboards.examDetail.Cancellation" />
												</div>
											</NavLink>
										</NavItem>
									)}

								{props.acessoPermitido(props.usuario, acessos.ReabrirEtapaMaterial) &&
									(props.finalizado && !props.exameFinalizado) && (
										<NavItem>
											<NavLink
												className={classnames({ active: props.active === '12' })}
												onClick={() => {
													setOpenModalConfirmar(!openModalConfirmar);
												}}
											>
												<div>
													<i className="mv-basico-reabrir"></i>
													<IntlMessage id="dashboards.examDetail.reopenStep" />
												</div>
											</NavLink>
											<ModalConfirmar
											toggleModalConfirmar={() =>
												setOpenModalConfirmar(false)
											}
											showModalConfirmar={openModalConfirmar}
											titulo={`${intl.formatMessage({id:"dashboards.examDetail.reopenStep"}) }`}
											mensagem={`${intl.formatMessage({id:"dashboards.examDetail.reopenStepQuestion"}) }`}
											confirmar={() =>
												props.reabrirEtapa()
											}
											/>
										</NavItem>
									)}

								{props.exibirChecklistRecebimento && (
									<NavItem>
										<NavLink
											className={classnames({ active: props.active === '10' })}
											onClick={() => {
												props.toggle('10');
											}}
										>
											<div
												className={`btn-checklist ${
													props.bloquearRecebimento ? 'bloqueado' : ''
												}`}
											>
												<i className="fas fa-tasks"></i>
												<IntlMessage id="dashboards.examDetail.checklist" />
											</div>
										</NavLink>
									</NavItem>
								)}

								{props.acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
									props.acessoPermitido(
										props.usuario,
										acessos.Rastreabilidade
									) && (
										<NavItem>
											<NavLink
												className={classnames({
													active: props.active === '11',
												})}
												onClick={() => {
													props.toggle('11');
												}}
											>
												<div>
													<i className="mv-basico-estrategia"></i>
													<IntlMessage id="dashboards.examDetails.traceability" />
												</div>
											</NavLink>
										</NavItem>
									)}
								<NavItem>
									<NavLink
										className={classnames({ active: props.active === '11' })}
										onClick={() => {
											setOpenModalInfoObito(!openModalInfoObito);
										}}
									>
										<div>
											<i className="mv-basico-cadastro"></i>
											<IntlMessage id="data.obito" />
										</div>
									</NavLink>
								</NavItem>

								{props.agruparExames && (<NavItem>
									<NavLink
										className={classnames({ active: props.active === '12' })}
										onClick={() => {
											setOpenModalLaudoAgrupado(!openModalLaudoAgrupado);
										}}
									>
										<div>
											<i className="mv-basico-agrupar"></i>
											<IntlMessage id="dashboard.groupExams.modal" />
										</div>
									</NavLink>
								</NavItem>)}
							</Nav>
							<ModalInfoObito
								intl={intl}
								isOpen={openModalInfoObito}
								setOpenModalInfoObito={setOpenModalInfoObito}
								laudoId={props.detalhes.laudo}
							/>

						<LaudoAgrupadoModal
								intl={intl}
								isOpen={openModalLaudoAgrupado}
								laudo={props.detalhes.laudo}
								setOpenModalLaudoAgrupado={setOpenModalLaudoAgrupado}
							/>
							{/* <ModalConfirmar>
								titulo={''}
								isOpen={openModalConfirmar}
								mensagem={<IntlMessage id="dashboards.examDetail.reopenStep" /> + '?'}
								onConfirmar={() => {
													props.reabrirEtapa()
												}}
							</ModalConfirmar> */}


							<TabContent activeTab={props.active}>
								{props.acessoPermitido(
									props.usuario,
									acessos.RecebimentoMaterial
								) && (
									<TabPane tabId={'1'}>
										{props.active === '1' && (
											<ReceberContainer
												microAplicavel={props.microAplicavel}
												history={props.history}
												altura={props.altura - 144}
											/>
										)}
									</TabPane>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.NaoConformidades
								) && (
									<TabPane tabId={'2'}>
										{props.active === '2' && (
											<InconformidadeContainer
												altura={props.altura - 44}
												funcFechar={props.fecharDetalhes}
												etapa={'MATERIAL'}
											/>
										)}
									</TabPane>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.ExamesEmAberto
								) && (
									<TabPane tabId={'3'}>
										{props.active === '3' && (
											<ExamesContainer altura={props.altura - 44} />
										)}
									</TabPane>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.VincularExame
								) && (
									<TabPane tabId={'4'}>
										{props.active === '4' && (
											<VincularContainer
												history={props.history}
												altura={props.altura - 44}
												funcFechar={props.fecharDetalhes}
											/>
										)}
									</TabPane>
								)}
								{props.acessoPermitido(props.usuario, acessos.Etiqueta) && (
									<TabPane tabId={'5'}>
										{props.active === '5' && (
											<EtiquetaContainer
												altura={props.altura - 144}
												callbackClose={props.closeEtiqueta}
												detalhes={props.detalhes}
											/>
										)}
									</TabPane>
								)}
								{props.acessoPermitido(props.usuario, acessos.Anexo) && (
									<TabPane tabId={'6'}>
										{props.active === '6' && (
											<AnexoContainer altura={props.altura - 144} />
										)}
									</TabPane>
								)}
								{props.acessoPermitido(props.usuario, acessos.DocExterno) && (
									<TabPane tabId={'9'}>
										{props.active === '9' && (
											<DocumentosExternosContainer altura={props.altura - 44} />
										)}
									</TabPane>
								)}
								{props.acessoPermitido(
									props.usuario,
									acessos.MultiplosExames
								) && (
									<TabPane tabId={'7'}>
										{props.active === '7' && (
											<MultiplosExamesContainer altura={props.altura - 144} />
										)}
									</TabPane>
								)}
								{props.acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
									props.acessoPermitido(
										props.usuario,
										acessos.CancelamentoMATERIAL
									) && (
										<TabPane tabId={'8'}>
											{props.active === '8' && (
												<CancelamentoContainer
													history={props.history}
													altura={props.altura - 144}
												/>
											)}
										</TabPane>
									)}
								<TabPane tabId={'10'}>
									{props.active === '10' && (
										<ChecklistContainer altura={props.altura - 44} />
									)}
								</TabPane>
								{props.acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
									props.acessoPermitido(
										props.usuario,
										acessos.Rastreabilidade
									) && (
										<TabPane tabId={'11'}>
											{props.active === '11' && (
												<RastreabilidadeContainer altura={props.altura - 44} />
											)}
										</TabPane>
									)}
							</TabContent>
						</div>
					</Col>
				</Row>
				<Row
					className="justify-content-end"
					style={{ bottom: '-10px', position: 'fixed' }}
				>
					<Col sm="auto">
						<Button
							color="link"
							onClick={props.fecharDetalhes}
							title="CTRL+ALT+O"
						>
							<IntlMessage id="dashboards.examDetail.close" />
						</Button>
						{props.acessoPermitido(
							props.usuario,
							acessos.RecebimentoMaterial
						) &&
							props.acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
							!props.finalizado &&
							!props.exameFinalizado && (
								<Button
									color="danger"
									//disabled={props.finalizado || props.exameFinalizado}
									onClick={() => {
										props.salvar(false);
									}}
								>
									<IntlMessage id="dashboards.examDetail.savePending" />
								</Button>
							)}
						{props.acessoPermitido(
							props.usuario,
							acessos.RecebimentoMaterial
						) &&
							props.acessoPermitido(props.usuario, acessos.Concluir) &&
							!props.existeNaoConformidadeImpeditiva &&
							!props.finalizado &&
							!props.exameFinalizado && (
								<Button
									color="success"
									//disabled={props.finalizado || props.exameFinalizado}
									onClick={() => {
										props.salvar(true);
									}}
								>
									<IntlMessage id="dashboards.examDetail.finalize" />
								</Button>
							)}
					{/* {(props.finalizado && !props.exameFinalizado && props.acessoPermitido(props.usuario, acessos.ReabrirEtapaMaterial)) && (
					<Button
						color="danger"
						onClick={() => {
							props.reabrirEtapa();
						}}
					>
						<IntlMessage id="dashboards.examDetail.reopenStep" />
					</Button>
					)} */}
						{(props.finalizado || props.exameFinalizado) && (
							<Button
								color="primary"
								onClick={() => {
									props.goProximaEtapa();
								}}
							>
								<IntlMessage id="dashboards.examDetail.nextStep" />
							</Button>
						)}
					</Col>
				</Row>
			</Col>
		)
	);
}

export default MaterialPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.page.js